import CsatByDeviceBarChart from './CsatByDeviceBarChart';
export default CsatByDeviceBarChart;



// WEBPACK FOOTER //
// ./src/components/CsatByDeviceBarChart/index.js